<template>
    <span class="diff">
        <component
            :is="getTagName(part)"
            v-for="(part, idx) in diffParts"
            :key="idx"
            class="diff-part"
        >{{ part.text }}</component>
    </span>
</template>

<script>
import { computed } from 'vue'
import diff from 'fast-diff';

export default {
    name: 'Diff',
    props: {
        string1: {
            type: String,
            required: true,
        },
        string2: {
            type: String,
            required: true,
        },
        mode: {
            type: String,
            default: 'diff',
            validator: (value) => ['diff', 'highlight'].includes(value),
        },
        hideParts: {
            type: String,
            default: 'none',
            validator: (value) => ['none', 'ins', 'del', 'equal'].includes(value),
        },
    },
    setup (props) {
        const diffParts = computed(() => {
            const parts = diff(props.string1 ?? '', props.string2 ?? '')
                .map(([op, text]) => ({ op, text }))

            // Possibility to hide specific parts of the diff
            // Mainly used when highlighting differences (in combination with mode="highlight")
            switch (props.hideParts) {
                case 'ins':
                    return parts.filter((part) => part.op !== diff.INSERT)
                case 'del':
                    return parts.filter((part) => part.op !== diff.DELETE)
                case 'equal':
                    return parts.filter((part) => part.op !== diff.EQUAL)
                case 'none':
                default:
                    return parts
            }
        })

        const getTagName = (part) => {
            if (props.mode === 'diff' && part.op === diff.INSERT) {
                return 'ins'
            }
            if (props.mode === 'diff' && part.op === diff.DELETE) {
                return 'del'
            }
            if (props.mode === 'highlight' && part.op !== diff.EQUAL) {
                return 'mark'
            }
            return 'span'
        }

        return {
            diff,
            diffParts,
            getTagName,
        }
    },
}
</script>

<style scoped>
.diff {
    white-space: pre-wrap;
}
</style>
